import script from "./MallProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./MallProducts.vue?vue&type=script&setup=true&lang=js"

import "./MallProducts.vue?vue&type=style&index=0&id=71651612&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71651612"]])

export default __exports__